var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.preview.color",
  title: "Control Preview: Color",
  description: "Read-only preview renderer for color values.",
  fields: {
    "value": { title: "Value", type: "string", description: "Color value to preview." }
  }
});

var helper = require("./helpers/control.preview.js");

function normalizeColor(value) {
  var raw = (value || "").toString().trim();
  if (!raw) return "";
  return raw;
}

exports.render = async function(options) {
  var color = normalizeColor(options.value);
  if (!color) {
    return helper.renderDoc({
      n: "span",
      c: "ua-control-preview-empty",
      i: "Not provided"
    });
  }

  return helper.renderDoc({
    n: "div",
    c: "ua-control-preview-color",
    i: [
      {
        n: "span",
        c: "ua-control-preview-color-swatch",
        style: "background-color: " + color + ";"
      },
      {
        n: "span",
        c: "ua-control-preview-color-text",
        i: color
      }
    ]
  });
};
